module.exports = __webpack_public_path__ + "static/img/cancel.2dd54b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cancel.png
// module id = rs4p
// module chunks = 1